import { updateMemberGroup } from '@/services/member/member'
import { Member } from '@/services/member/member.model'
import { useRequest } from 'ahooks'
import { Button, Form, Input } from 'antd'
import React, { memo, useEffect } from 'react'

interface EditGroupNameProps {
  currentGroup: Member.MemberGroup
  orgId: number
  onCancel: () => void
  onSuccess: () => void
}

export default memo<EditGroupNameProps>(function EditGroupName(props) {
  const { currentGroup, orgId, onCancel, onSuccess } = props
  const [form] = Form.useForm()
  const { run } = useRequest(updateMemberGroup, {
    manual: true,
    onSuccess: () => {
      onCancel()
      onSuccess()
    }
  })

  useEffect(() => {
    form.setFieldsValue(currentGroup)
  }, [])

  return (
    <Form
      form={form}
      layout='inline'
      onFinish={(values) => {
        run(orgId, currentGroup.id, values)
      }}
    >
      <Form.Item name='name'>
        <Input style={{ width: '250px' }} placeholder='' />
      </Form.Item>

      <Button type={'primary'} className={'mr-2'} htmlType={'submit'}>
        Save
      </Button>

      <Button type={'default'} htmlType={'button'} onClick={onCancel}>
        Cancel
      </Button>
    </Form>
  )
})
